import { TechnicianCommentButton } from './TechnicianCommentButton'
import { LeaveSessionButton } from './LeaveSessionButton'
import { SidebarTrigger } from '@/components/ui/sidebar'

export const DocumentToolbar = () => {
  return (
    <div className="flex z-30 w-full bg-white min-h-12 h-auto py-1 shadow-md shadow-stone-200/70">
      <div className="flex items-center space-x-2 w-full justify-between px-6">
        <div className="flex items-center space-x-4">
          <div className="block md:hidden">
            <SidebarTrigger />
          </div>
          <TechnicianCommentButton />
        </div>
        <LeaveSessionButton />
      </div>
    </div>
  )
}
